module.exports = __webpack_public_path__ + "img/Presentation4_old.61a7b0e6.png";